export const defaultState = {
  isFetching: false,
  hasFailed: false,
  errorMsg: "",
  data: {
    latestPosts: {results: [], meta: {}},
    forYouPosts: {results: [], meta: {}},
    savedPosts: [],
  },
  categories: [],
};
